<template>
  <div>
    <el-select
      @change="selectDssz()"
      v-model="cronType"
      class="m-2"
      style="width:100%"
      placeholder="无"
    >
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      />
    </el-select>
    <br />
    <el-button type="" @click="addClick()" v-if="cronType !== ''"
      >添加</el-button
    >
    <el-row
      style="margin-top:10px"
      v-for="(item, index) in tableParams.timesResps"
      :key="index"
    >
      <el-row>
        <el-col :span="24" v-if="cronType === '4'">
          <h-date-timerange
            v-model:end="tableParams.endTime"
            v-model:start="tableParams.startTime"
          >
          </h-date-timerange>
        </el-col>
      </el-row>
      <el-col :span="2"></el-col>
      <el-col
        :span="6"
        v-if="cronType === '2' || cronType === '3' || cronType === '1'"
      >
        <el-time-select
          v-model="item.startTime"
          start="0:0"
          step="01:00"
          end="24:00"
        ></el-time-select>
      </el-col>
      <el-col
        style="margin-left:10px"
        :span="6"
        v-if="cronType === '2' || cronType === '3' || cronType === '1'"
      >
        <el-time-select
          v-model="item.endTime"
          start="0:0"
          step="01:00"
          end="24:00"
        ></el-time-select>
      </el-col>
      <el-col :span="24" v-if="cronType === '2' || cronType === '3'">
        <div class="zyclass">
          <div
            :class="{ zyclassHover: item.days.includes(items) }"
            v-for="items in cronType === '2' ? 7 : 31"
            :key="items"
            @click="hoverClick(item.days, items)"
          >
            {{ cronType === "2" ? zhouList[items] : items }}
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { defineComponent, reactive, toRefs } from "vue";
import HDateTimerange from "./HDateTimerange.vue";

export default defineComponent({
  components: { HDateTimerange },
  name: "HLoopTime",
  setup() {
    const state = reactive({
      cronType: "",

      tableParams: {
        timesResps: [
          {
            days: [],
            endTime: "",
            startTime: ""
          }
        ]
      },
      zhouList: ["", "周一", "周二", "周三", "周四", "周五", "周六", "周日"],
      options: [
        {
          label: "无",
          value: ""
        },
        {
          label: "按日循环",
          value: "1"
        },
        {
          label: "按周循环",
          value: "2"
        },
        {
          label: "按月循环",
          value: "3"
        },
        {
          label: "不循环",
          value: "4"
        }
      ]
    });
    const selectDssz = () => {
      state.tableParams.timesResps = [
        {
          days: [],
          endTime: "",
          startTime: ""
        }
      ];
    };

    return {
      ...toRefs(state),
      selectDssz
    };
  }
});
</script>
<style scoped lang="scss">
.zyclass {
  display: flex;
  font-size: 12px;
  flex-wrap: wrap;
  padding: 0 50px;
  padding-top: 20px;
  div {
    text-align: center;
    line-height: 50px;
    width: 50px;
    height: 50px;
    border: 1px solid #dcdee3;
    border: 1px solid #dcdee3;
    cursor: pointer;
  }
}
.zyclassHover {
  color: #fff;
  background-color: #5584ff;
}
</style>
